<ng-container *ngIf="!isHidden">
    <map-loading *ngIf="isLoading; else loaded">{{ "mapWaitingPlaceholder" | translate}}...</map-loading>

    <ng-template #loaded>
        <multistage-map-container
        [multistageConfig]="multistageConfig!"
        [segmentLabelType]="control.segmentLabelType!"
        [readOnly]="isDisabled"
        [selectOnly]="control.selectOnly"
        [oneLineDispositionMaps]="control.selectOnly"
        [buttonsConfiguration]="control.legendActionsConfiguration!"
        [legendColors]="colorLegend"
        [isHorizontal]="control.isHorizontal!"
        [isWithTooltip]="control.isWithTooltip!"
        [isWithViewId]="control.isWithViewId!"
        [isWithStageName]="control.isWithStageName!"
        [fixedColumnNumber]="fixedColumnNumber!"
        [fixedLayout]="fixedLayout"
        [viewTopLabel]="_viewTopLabel"
        [viewBottomLabel]="_viewBottomLabel"
        [configuredRowNumber]="control.rowSpan"
        (dataUpdate)="onDataUpdate($event)">
            <ng-container extra-buttons-legend>
                <cp-additional-content
                    *ngFor="let additionalContent of control.additionalContent"
                    [control]="additionalContent"
                    [cardId]="cardId"
                    [disabled]="isDisabled">
                </cp-additional-content>
            </ng-container>
        </multistage-map-container>
    </ng-template>
</ng-container>
